import api from "api/config";

// GET RESERVATION PREFERENCES
export const getReservationPreferencesAPI = async (hotelId, reservationId) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/preferences/hotels/${hotelId}/reservations/${reservationId}`,
  });

  return response.data;
};
